import apiService,{ HOST,showPdfNewTab } from "./BaseApi";
import Utils from '@/scripts/Utils';
import { showErrorSnackBar, showSuccessSnackBar } from "@/utils/SnackBartHelper"
const ENDPOINT_PATH = "/consumption/generate-pdf";

const downloadPdf = async (response) => {  
    if (response.status === 200 && response.data.signedUrl) showPdfNewTab(response.data.signedUrl)
    else showErrorSnackBar("Erro ao gerar proposta. Tente novamente!")
}

const EconomyApi = {
    generateConsumptionPdf: async (params) => {
        params = {...params, env: Utils.getEnv()}
        return await apiService.post(ENDPOINT_PATH, params)
        // await downloadPdf(response)
    },
};

export default EconomyApi;
